export default "__VITE_ASSET__112e1d51__"